import { terbilang } from "../../../utils/terbilang";


interface QuotationPriceInformationProps {
  subtotal: number;
  discount: number; // persentase
  ppn: number; // persentase
  grandTotal: number;
}

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(value || 0);

export default function QuotationPriceInformation({
  subtotal,
  discount,
  ppn,
  grandTotal,
}: QuotationPriceInformationProps) {
  const discountAmount = subtotal * (discount / 100);
  const totalAfterDiscount = subtotal - discountAmount;
  const ppnAmount = totalAfterDiscount * (ppn / 100);

  return (
    <div className="rounded-2xl border border-gray-100 p-5">
      <h3 className="mb-4 font-semibold">Price Information</h3>

      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-100 text-left text-gray-500">
            <th className="pb-2 font-medium">No</th>
            <th className="pb-2 font-medium">Total</th>
            <th className="pb-2 font-medium">Discount</th>
            <th className="pb-2 font-medium">Sub Total</th>
            <th className="pb-2 font-medium">PPN {ppn}%</th>
            <th className="pb-2 font-medium">Grand Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="py-2">1</td>
            <td className="py-2">{formatCurrency(subtotal)}</td>
            <td className="py-2">{discount}%</td>
            <td className="py-2">{formatCurrency(totalAfterDiscount)}</td>
            <td className="py-2">{formatCurrency(ppnAmount)}</td>
            <td className="py-2 font-semibold">{formatCurrency(grandTotal)}</td>
          </tr>
        </tbody>
      </table>

      <p className="mt-3 text-xs italic text-gray-500">
        *Terbilang: {terbilang(grandTotal)}
      </p>
    </div>
  );
}
